const api = {
  getStackCodes() {
    return `/stack-code-settings/user`;
  }
};

export default api;
